import { Heading, Flex, Box, BoxProps } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import React from 'react'

import type { HeadingProps } from '@chakra-ui/react'

interface Props extends BoxProps {
  as?: HeadingProps['as']
  children: React.ReactNode
}

export default function HeadingText({ as, children, ...restProps }: Props) {
  const router = useRouter()

  return (
    <Heading paddingBottom="16px" as={as} {...restProps}>
      <Flex>
        <Box w="5px" h={router.locale === 'jp' ? '45px' : '38px'} bgColor="#e06354" marginRight="8px"></Box>
        {children}
      </Flex>
    </Heading>
  )
}
